<template>
    <span class="backTop" @click="backTop">
      <img src="../../assets/images/img_back.png" alt="" />
    </span>
</template>
<script>
  const cHeight = document.body.clientHeight || document.documentElement.clientHeight || window.innerHeight;
  export default{
    mounted(){
      let self = this;
      if(!!window.ActiveXObject || 'ActiveXObject' in window){
        self.isIE = true;
      }

      // setTimeout(()=>{
      //    if(document.body.scrollTop>cHeight || document.documentElement.scrollTop>cHeight){
      //     spanEle.style.display = 'block';
      //     // self.flag = true;
      //    }
      // },500);

      if(!self.isIE){
         setInterval(()=>{
          if(!document.body.onscroll){
            document.body.onscroll = function(){
              let _dis = document.documentElement.scrollTop || document.body.scrollTop,spanEle = document.querySelector('.backTop');
              //console.log(_dis);
              if(_dis>cHeight){
                spanEle.style.display = 'block';
                // self.flag = true;
              }else{
                spanEle.style.display = 'none';
                // self.flag = false;
              }
              // console.log( self.flag);
            };
          }
        },500);
      }else if(self.isIE){
        window.onscroll = function(){
          let _dis = window.scrollTop || document.documentElement.scrollTop,spanEle = document.querySelector('.backTop');
          if(_dis>cHeight){
            spanEle.style.display = 'block';
            // self.flag = true;
          }else{
            spanEle.style.display = 'none';
            // self.flag = false;
          }
        };
      }
    }
    ,data(){
      return {
        flag:false,
        isIE:false
      }
    }
    ,methods:{
      backTop(){
        let topInterval,step = document.body.scrollTop/10 || document.documentElement.scrollTop/10;
        if(!this.isIE){
          topInterval = setInterval(()=>{
            if(document.body.scrollTop){
              document.body.scrollTop = document.body.scrollTop-step;
              if(document.body.scrollTop<=0){
                clearInterval(topInterval);
              }
            }else if(document.documentElement.scrollTop){
              document.documentElement.scrollTop = document.documentElement.scrollTop-step;
              if(document.documentElement.scrollTop<=0){
                clearInterval(topInterval);
              }
            }
          },30);
          
        }else if(this.isIE){
          topInterval = setInterval(()=>{
            document.documentElement.scrollTop = document.documentElement.scrollTop-step;
            if(document.documentElement.scrollTop<=0){
              clearInterval(topInterval);
            }
          },30);
        }
      }
    }
  }
</script>
<style lang="less">
  .backTop{
    position:fixed;
    right:30px;
    bottom:50px;
    cursor:pointer;
    display:none;
    z-index:100;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/backTop.vue